import { render } from "./ViewCommandePage.vue?vue&type=template&id=37f1b77e&ts=true"
import script from "./ViewCommandePage.vue?vue&type=script&lang=ts"
export * from "./ViewCommandePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__